import script from "./CampaignsAdditionalSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsAdditionalSection.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsAdditionalSection.vue?vue&type=style&index=0&id=0eab86f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eab86f0"]])

export default __exports__